export type FlagsFromServiceObject = {
    [key: string]: boolean;
};

export function extractFlagsFromServiceData(flagsFromService: string[]): FlagsFromServiceObject {
    return flagsFromService.reduce((agg: FlagsFromServiceObject, flagFromService) => {
        agg[flagFromService.toLowerCase()] = true;
        return agg;
    }, {});
}
